'use client';
import { Heart } from '@phosphor-icons/react';
import { useLocale } from 'next-intl';
import { Link } from '@/i18n/navigation';
import { useWishlist } from '@/lib/wishlist/WishlistContext';

export default function WishlistIcon() {
  const { count } = useWishlist();
  const locale = useLocale();

  return (
    <Link
      href="/account/wishlist"
      aria-label={locale === 'ar' ? 'المفضلة' : 'Wishlist'}
      className="tap-target relative inline-flex items-center justify-center w-10 h-10 text-foreground hover:text-primary transition-colors rounded-lg focus-visible:ring-2 focus-visible:ring-ring"
    >
      <Heart size={22} />
      {count > 0 && (
        <span
          key={count}
          className="absolute -top-1 -end-1 bg-primary text-primary-foreground rounded-full w-5 h-5 text-xs flex items-center justify-center font-medium leading-none animate-in zoom-in duration-200"
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  );
}
